import styles from './ButtonSpinner.module.scss';

const ButtonSpinner = () => {
  return <div className={styles.spinner} />;
};

export default ButtonSpinner;
